import { render, staticRenderFns } from "./LimitedShopModal.vue?vue&type=template&id=65c1105c&"
import script from "./LimitedShopModal.vue?vue&type=script&lang=ts&"
export * from "./LimitedShopModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports